// extracted by mini-css-extract-plugin
export default {"strike":"PageDivider_strike__PHjOl","strike2":"PageDivider_strike2__Pc9Up"};